import type { UnitConversion } from '@familychef/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { supabase } from '../lib/supabase';

export type ConversionRow = UnitConversion & { id?: string };

export function useConversions() {
  return useQuery({
    queryKey: ['conversions'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('unit_conversions')
        .select('*')
        .order('unit_type', { ascending: true });
      if (error) throw error;
      return (data ?? []) as ConversionRow[];
    },
  });
}

export function useUpsertConversion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (row: ConversionRow) => {
      const { error } = await supabase.from('unit_conversions').upsert(row);
      if (error) throw error;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['conversions'] }),
  });
}

export function useDeleteConversion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (row: { from_unit: string; to_unit: string }) => {
      const { error } = await supabase
        .from('unit_conversions')
        .delete()
        .eq('from_unit', row.from_unit)
        .eq('to_unit', row.to_unit);
      if (error) throw error;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['conversions'] }),
  });
}
